import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import App from './App.vue'
import router, { initDynamicRoutes } from './router'
import store from './store'
import api from './api'
import permission from './directives/permission'
import dialogDrag from './directives/dialogDrag'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 将API挂载到Vue实例上
Vue.prototype.$api = api

// 注册权限指令
Vue.directive('permission', permission)
// 注册弹窗拖拽指令
Vue.directive('dialog-drag', dialogDrag)

// 初始化动态路由（处理刷新页面情况）
// 只有在有用户信息时才初始化动态路由
const userInfo = store.state.userInfo
if (userInfo && userInfo.menus) {
  console.log('应用启动时发现用户信息，初始化动态路由')
  initDynamicRoutes()
} else {
  console.log('应用启动时未发现用户信息，跳过动态路由初始化')
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
